/**
 * Order from state.
 *
 * @param state
 * @return {string}
 */
export function orderFromState(state) {

  if (!state.orderBy)
    return '';

  if (typeof state.orderBy === 'string') {

    const direction = state.orderDesc
      ? 'DESC'
      : 'ASC';

    return `${state.orderBy} ${direction}`;
  }

  return state.orderBy;
}

/**
 * Search state to filter.
 *
 * @param state
 * @param filter
 */
export function searchStateToFilter(state, filter) {

  if (
    !state.searchQuery ||
    !state.searchBy.length
  ) return;

  const fields = state
    .searchBy;

  const words = state
    .searchQuery
    .split(' ')
    .filter(v => v);

  filter.where = filter.where || {};
  filter.where.and = filter.where.and || [];

  const and = filter
    .where
    .and;

  words.forEach(word => {

    const or = [];

    fields.forEach(field => {

      or.push({
        [field]: word,
      });

      or.push({
        [field]: {
          like: word,
          options: 'i',
        },
      });
    });

    const number = Number(word);

    if (!Number.isNaN(number))
      fields.forEach(
        field => or.push({
          [field]: number,
        }),
      );

    and.push({or});
  });
}

/**
 * Message from error.
 *
 * @param error
 * @param fallback
 * @return {string}
 */
export function messageFromError(
  error,
  fallback = 'Неизвестная ошибка',
) {
  let message = error
    && error.response
    && error.response.data
    && error.response.data.error
    && error.response.data.error.message;
  if (typeof message === 'string' && message) return message;
  message = error
    && error.error
    && error.error.message;
  if (typeof message === 'string' && message) return message;
  return error.message || fallback;
}

/**
 * Code from error.
 *
 * @param error
 * @param fallback
 * @return {string}
 */
export function codeFromError(
  error,
  fallback = '',
) {

  return (error
    && error.response
    && error.response.data
    && error.response.data.error
    && error.response.data.error.code
  ) || error.code || fallback;
}

/**
 * Status code from error.
 *
 * @param error
 * @param fallback
 * @return {string}
 */
export function statusCodeFromError(
  error,
  fallback = 0,
) {

  return (error
    && error.response
    && error.response.data
    && error.response.data.error
    && error.response.data.error.statusCode
  ) || fallback;
}
